import * as actionTypes from './actionTypes'

const initialState = {
    addressDetails: [],
    orderDetails: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_ADDRESS:
            state = {
                ...state,
                addressDetails: action.payload.data,
            }
            break;
        case actionTypes.UPDATE_ORDER_PREVIEW:
            state = {
                ...state,
                [action.payload.name]: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
